export default __webpack_public_path__ + "static/media/shop.a4f4be07.svg";